export default {
  app: {
    test: window.location.hostname === 'test.m.wkbins.com' || window.location.hostname === 'test1.m.wkbins.com'
  },
  images: {
    root: 'static/images/',
    banner: 'banner.png', // banner
    wkbLogo: 'wkb_logo.png', // 悟空保Logo
    partnerLogo: 'hengqin_logo.png' // 合作伙伴的Logo
  },
  navs: [
    {
      name: '产品介绍',
      ref: 'nav1'
    },
    {
      name: '常见问题',
      ref: 'nav2'
    },
    {
      name: '用户评价',
      ref: 'nav3'
    },
    {
      name: '理赔流程',
      ref: 'nav4'
    }
  ],
  audio: 'static/audios/bossm4a.m4a', // 老大的音频
  questions: [ // 常见问题
    {
      q: '为什么悟空保定制的产品性价比是完爆香港保险的？',
      a: '香港保险一直都是低价优质的保险代言词，但也存在以下弊端：复杂产品设计导致销售误导，高额渠道成本导致价格昂贵，冗长服务流程导致体验不好。 悟空保产品理念是：产品极简，价格最低，体验最好！1、将理财和风险保障分开，产品标准，易比价，让普通百姓从此看懂保险，而不至于被误导；2、将定价和渠道费用压缩，成本下降，更实惠，让普通百姓从此少花金钱，却拥有高额保障；3、将投保和理赔服务挂网，线上体验，更便捷，让普通百姓从此自主选择，且免受杂乱骚扰。'
    },
    {
      q: '为什么要购买定期寿险？',
      a: '定期寿险的功能是阶段性规避家庭主要经济支柱因为风险而全残或离去，用高额的保险赔偿金替代原本未来可以持续攀升的薪资等收入，来履行父母赡养、孩子抚养和配偶责任等未竟的人生义务，让家人的生活品质不降低，活得更有尊严！ 定期寿险的本质是对家人的爱与责任，让家人有安全感，希望每个家庭都有一份至尊保，后顾无忧，将爱进行到底！ 买保险，再也不用去香港，只找悟空保！'
    },
    {
      q: '从悟空保购买保险有什么优势？',
      a: '1.产品真正回归保障，行业原创且独家销售；2.价格完爆香港保险，降低成本，提升保额，提升家庭风险保障杠杆；3.产品保额高达百万，免体检，无需提供房车、收入等隐私材料，用户体验大幅提升。'
    },
    {
      q: '至尊保定期寿险的购买有地区限制吗？',
      a: '全国（不含港澳台）各地均可投保。'
    },
    {
      q: '至尊保定期寿险可以给家人投保吗？',
      a: '仅限为本人投保，不接受为他人投保。'
    },
    {
      q: '至尊保定期寿险有等待期吗？',
      a: '至尊保定期寿险，等待期仅90天。'
    }
  ],
  h5Questions: [ // 常见问题
    {
      q: '为什么要购买定期寿险？',
      a: '定期寿险的功能是阶段性规避家庭主要经济支柱因为风险而全残或离去，用高额的保险赔偿金替代原本未来可以持续攀升的薪资等收入，来履行父母赡养、孩子抚养和配偶责任等未竟的人生义务，让家人的生活品质不降低，活得更有尊严！ 定期寿险的本质是对家人的爱与责任，让家人有安全感，希望每个家庭都有一份至尊保，后顾无忧，将爱进行到底！ 买保险，再也不用去香港，只找悟空保！'
    },
    {
      q: '至尊保定期寿险的购买有地区限制吗？',
      a: '全国（不含港澳台）各地均可投保。'
    },
    {
      q: '至尊保定期寿险可以给家人投保吗？',
      a: '仅限为本人投保，不接受为他人投保。'
    },
    {
      q: '至尊保定期寿险有等待期吗？',
      a: '至尊保定期寿险，等待期仅90天。'
    }
  ],
  processNotice: 'static/docs/lipeixuzhi.html' // 理赔须知 URL
}



// WEBPACK FOOTER //
// ./src/config/app.js